/**
 * Apps em que o cliente acompanha a geração, por marca testada (out/2026 —
 * configuração inicial). Usado onde o texto precisa citar o app: aviso do Free,
 * campo de geração manual ao salvar a fatura e o tutorial da Ajuda.
 *
 * `where` é o passo a passo em texto para achar a geração do período — sem
 * prints por enquanto (decisão do Bruno: os prints entram quando forem tirados
 * de contas reais).
 */
export interface InverterApp {
  brand: string;
  app: string;
  where: string[];
}

export const INVERTER_APPS: Record<string, InverterApp> = {
  growatt: {
    brand: 'Growatt',
    app: 'ShinePhone',
    where: [
      'Abra o ShinePhone e entre na sua usina.',
      'Toque no gráfico de geração e escolha a visão por dia ou por mês.',
      'Some os dias do período da fatura, ou use o total do mês.',
    ],
  },
  sungrow: {
    brand: 'Sungrow',
    app: 'iSolarCloud',
    where: [
      'Abra o iSolarCloud e entre na sua usina.',
      'Abra o histórico de geração (rendimento) por dia ou por mês.',
      'Some os dias do período da fatura, ou use o total do mês.',
    ],
  },
  fronius: {
    brand: 'Fronius',
    app: 'Solar.web',
    where: [
      'Abra o Solar.web e entre na sua usina.',
      'Abra a produção de energia por dia ou por mês.',
      'Some os dias do período da fatura, ou use o total do mês.',
    ],
  },
  ingeteam: {
    brand: 'Ingeteam',
    app: 'INGECON SUN Monitor',
    where: [
      'Abra o INGECON SUN Monitor e entre na sua instalação.',
      'Abra a energia produzida por dia ou por mês.',
      'Some os dias do período da fatura, ou use o total do mês.',
    ],
  },
};

export const INVERTER_APP_LIST = Object.entries(INVERTER_APPS).map(
  ([slug, info]) => ({ slug, ...info })
);
